import React from 'react';

interface CapacityNoticeProps {
  title: string;
  message: string;
  onUpgradeClick: () => void;
  emoji?: string;
}

const CapacityNotice: React.FC<CapacityNoticeProps> = ({
  title,
  message,
  onUpgradeClick,
  emoji = "🍺"
}) => {
  return (
    <div className="sf-card-highlight p-4 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center">
          <div className="flex-shrink-0 text-2xl mr-3">
            {emoji}
          </div>
          <div className="flex-1">
            <span className="text-sm font-semibold text-fg-bright">
              {title}
            </span>
            <span className="text-sm text-fg-body ml-2">
              {message}
            </span>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button
            onClick={onUpgradeClick}
            className="sf-btn-primary px-4 py-2.5 text-sm min-h-[44px] whitespace-nowrap"
          >
            Proost op Solofix!
          </button>
        </div>
      </div>
    </div>
  );
};

export default CapacityNotice;